import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import BrandMark from "../components/BrandMark";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | valid | invalid
  const [errMsg, setErrMsg] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitErr, setSubmitErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/api/auth/reset-password/${token}`)
      .then((r) => {
        if (r.data.valid) setStatus("valid");
        else { setStatus("invalid"); setErrMsg(r.data.error || "Ссылка недействительна"); }
      })
      .catch((e) => { setStatus("invalid"); setErrMsg(formatApiError(e.response?.data?.detail) || e.message); });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitErr("");
    if (pwd.length < 8) { setSubmitErr("Пароль должен быть не короче 8 символов"); return; }
    if (pwd !== confirm) { setSubmitErr("Пароли не совпадают"); return; }
    setBusy(true);
    try {
      await api.post(`/api/auth/reset-password/${token}`, { new_password: pwd });
      setDone(true);
      setTimeout(() => nav("/admin/login"), 1800);
    } catch (err) {
      setSubmitErr(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  if (status === "loading") {
    return <div className="min-h-screen flex items-center justify-center label-mono" data-testid="reset-loading">Проверка ссылки…</div>;
  }
  if (status === "invalid") {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="max-w-md text-center space-y-4" data-testid="reset-invalid">
          <div className="label-mono text-destructive">ССЫЛКА НЕДОСТУПНА</div>
          <h1 className="text-3xl font-medium tracking-tight">{errMsg}</h1>
          <p className="text-foreground/60">Запросите новую ссылку у администратора Hop.Agency.</p>
          <Link to="/admin/login" className="hop-link inline-block mt-4">← на страницу входа</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="reset-form">
        <div className="opacity-70 mb-4"><BrandMark /></div>
        <div>
          <Link to="/admin/login" className="hop-link text-sm">← на страницу входа</Link>
          <h2 className="text-3xl font-medium tracking-tight mt-3">Новый пароль</h2>
          <p className="text-sm text-foreground/60 mt-2">Минимум 8 символов.</p>
        </div>
        {done ? (
          <p className="label-mono text-foreground" data-testid="reset-success">ПАРОЛЬ ОБНОВЛЁН — ПЕРЕНАПРАВЛЕНИЕ…</p>
        ) : (
          <>
            <label className="block">
              <div className="label-mono mb-2">НОВЫЙ ПАРОЛЬ</div>
              <input data-testid="reset-pwd-input" className="field-input" value={pwd} onChange={(e) => setPwd(e.target.value)} type="password" required />
            </label>
            <label className="block">
              <div className="label-mono mb-2">ПОВТОРИТЕ ПАРОЛЬ</div>
              <input data-testid="reset-confirm-input" className="field-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} type="password" required />
            </label>
            {submitErr && <p className="text-destructive label-mono" data-testid="reset-error">{submitErr}</p>}
            <button type="submit" disabled={busy} className="btn-primary" data-testid="reset-submit-btn">
              {busy ? "Сохраняем…" : "Установить пароль"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
